<template>
  <div class="new-password">
    <label class="form-label" for="new-password"
      >{{ $t("message.set-password") }}*
      <a
        class="show-password ic ic-eye"
        @click.prevent="showPassword = !showPassword"
      >
        {{ showPasswordLabel }}</a
      ></label
    >
    <input
      class="form-input"
      :type="passwordFieldType"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :placeholder="$t('message.set-password')"
      name="new-password"
      autocomplete="new-password"
      required
    />
    <div class="password-requirements" v-if="value">
      <ul>
        <li
          v-for="req in passwordRequirements"
          :class="{ satisfied: req.satisfied }"
        >
          <span class="bullet primary-text">•</span>
          {{ req.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less" scoped>
.password-requirements {
  margin-bottom: 1.6em;
  margin-top: -0.6em;
  ul {
    columns: 2;

    li {
      padding-left: 18px;
      margin-bottom: 5px;
      position: relative;

      .bullet {
        position: absolute;
        left: 0;
        font-size: 40px;
        line-height: 14px;
      }

      &.satisfied {
        &,
        .bullet {
          color: #aaa !important;
        }
      }
    }
  }
}

.show-password {
  float: right;
  color: inherit;

  &:before {
    margin-right: 5px;
    color: #333;
  }
}
</style>

<script>
export default {
  data() {
    return {
      showPassword: false,
    };
  },
  props: {
    value: {
      type: String,
    },
  },
  async mounted() {},
  computed: {
    passwordRequirements() {
      const requirements = [
        { label: "One lowercase letter", check: (p) => !!p.match(/[a-z]/) },
        { label: "One uppercase letter", check: (p) => !!p.match(/[A-Z]/) },
        {
          label: "One number or symbol",
          check: (p) => !!p.match(/[^a-z]/i),
        },
        { label: "10 characters minimum", check: (p) => p.length >= 10 },
      ];

      return requirements.map((req) => {
        return {
          label: req.label,
          satisfied: req.check(this.value),
        };
      });
    },
    showPasswordLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    passwordFieldType() {
      return this.showPassword ? "text" : "password";
    },
  },
  methods: {},
};
</script>
